module.exports = __webpack_public_path__ + "img/logo-profile-empty.3a5cdd40.png";